"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtag = exports.installGtag = void 0;
const installGtag = (trackingId) => {
    const scriptId = "ga-gtag";
    if (document.getElementById(scriptId))
        return;
    const { head } = document;
    const script = document.createElement("script");
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    head.insertBefore(script, head.firstChild);
    window["dataLayer"] = window["dataLayer"] || [];
    (0, exports.gtag)("js", new Date());
    (0, exports.gtag)("config", trackingId);
};
exports.installGtag = installGtag;
/*
  Cannot use arrow func + destructuring/rest operator.
  "arguments" object in dataLayer is required (not an array of arguments).
*/
const gtag = function (...args) {
    window["dataLayer"].push(arguments);
};
exports.gtag = gtag;
